const validateUrl = (url) =>{
    const regex = /^(spotify:|https:\/\/[a-z]+\.spotify\.com\/)/
    return regex.test(url)
}

export default validateUrl;